// Types
import { GetStream_stream } from 'api/streams/types/GetStream';
import { GetMediaPost_getMediaPost_VideoPost } from 'api/mediaPost/types/GetMediaPost';
// Hooks
import { useBreakpoints } from 'hooks';
// Helpers
import { getStreamerName } from 'helpers/streams';
// Components
import TalentBlock from '../TalentBlock/TalentBlock';
// UI
import Text from 'ui3/Text/Text';
// Styles
import styles from './VideoHeader.module.scss';

type StoreType =
  | GetStream_stream['store']
  | GetMediaPost_getMediaPost_VideoPost['store'];

type VideoHeaderProps = {
  title: string;
  store: StoreType;
  isOwner?: boolean;
  actionButtons?: React.ReactNode;
};

const VideoHeader = ({
  title,
  store,
  isOwner = false,
  actionButtons,
}: VideoHeaderProps): JSX.Element => {
  const profilePath = `/${store?.slug}`;
  const streamerName = getStreamerName(store);
  const avatarURL =
    store?.storeDetails?.avatarURL || '/images/icons/avatar-placeholder.svg';
  const { isBreakpointL } = useBreakpoints();

  return (
    <div className={styles.root}>
      <Text as="h1" variant={isBreakpointL ? 'h5' : 'h6'}>
        {title}
      </Text>
      <div className={styles.streamerActionRow}>
        <TalentBlock
          store={store}
          talentName={streamerName}
          avatarURL={avatarURL}
          profilePath={profilePath}
          showFollowButton={!isOwner}
          className={styles.talentBlock}
          priority
        />
        {actionButtons && (
          <div className={styles.actionButtons}>{actionButtons}</div>
        )}
      </div>
    </div>
  );
};

export default VideoHeader;
